import React from 'react';
import { FilterType } from '../../types/hospital.types';
import './HospitalFilters.css';

interface HospitalFiltersProps {
  filter: FilterType;
  searchTerm: string;
  isDeleted: boolean;
  insuranceFilter: string;
  onFilterChange: (filter: FilterType) => void;
  onSearchChange: (term: string) => void;
  onDeletedChange: (isDeleted: boolean) => void;
  onInsuranceChange: (insurance: string) => void;
}

const HospitalFilters: React.FC<HospitalFiltersProps> = ({
  filter,
  searchTerm,
  isDeleted,
  insuranceFilter,
  onFilterChange,
  onSearchChange,
  onDeletedChange,
  onInsuranceChange
}) => {
  return (
    <div className="filters">
      <select value={filter} onChange={(e) => onFilterChange(e.target.value as FilterType)}>
        <option value="all">All Hospitals</option>
        <option value="esic">ESIC Only</option>
        <option value="emergency">Emergency Care</option>
      </select>
      <input
        type="text"
        placeholder="Search hospital name, address, or city..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
      />
      <input
        type="text"
        placeholder="Filter by insurance..."
        value={insuranceFilter}
        onChange={(e) => onInsuranceChange(e.target.value)}
      />
      <label className="checkbox-label">
        <input
          type="checkbox"
          checked={isDeleted}
          onChange={(e) => onDeletedChange(e.target.checked)}
        />
        Show Deleted
      </label>
    </div>
  );
};

export default HospitalFilters;